import { darken } from 'polished';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  height: auto;
  gap: 2rem;
  font-size: 1rem;
  padding: 1rem;
`;

export const ModalFooterButtons = styled.footer`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1rem;
`;

export const CancelButton = styled(Button)`
  && {
    color: #424242;
  }
`;

export const DeleteButton = styled(Button)`
  && {
    background-color: #d32f2f;
    color: white;
    &:hover {
      background-color: ${darken(0.1, '#d32f2f')};
    }
  }
`;
